import type { AnyRouter } from '@tanstack/react-router';
import { isUntrackedPath } from './paths';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Pushes a `wbs_page_view` for every resolved route, the initial one included.
 * The GA4 tag listens for this event instead of a History Change trigger,
 * which would also fire on console navigations.
 *
 * Pathname only: legacy GA saw full URLs, including keys in email-verify and
 * reset links. No `dataLayer` means the tag never loaded (the entry page was
 * /admin or /front), so a later member-side navigation stays unreported too.
 */
export function trackPageViews(router: AnyRouter): () => void {
  return router.subscribe('onResolved', ({ toLocation }) => {
    const pathname = toLocation.pathname;
    if (isUntrackedPath(pathname) || !Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: 'wbs_page_view',
      page_path: pathname,
      page_location: window.location.origin + pathname,
      page_title: document.title,
    });
  });
}
